import { GenderTypes } from 'src/app/feed-advice/models/feed-advice.model';
import {
  Calculation,
  CountryOptions,
  ExtendedSimulation,
  FeederType,
  GenderOptions,
  PriceSetting,
  QuickSimulation,
} from 'src/app/feed-profit/models/feed-profit.model';
import { Discount } from 'src/app/settings/models/settings.model';

export const FEED_PROFIT_CONSTANTS = {
  baselineSettings: {
    growthStartNorm: 700,
    growthEndNorm_boar_gilt: 900,
    growthEndNorm_barrow_gilt: 850,
  },
};

export const FEED_PROFIT_MANURE_VALUES = {
  K: 10.09,
  Na: 1.3,
};

export const FEED_PROFIT_ENERGY_VALUES = {
  lowerbounds: [
    2.49, 2.553325, 2.635075, 2.716825, 2.798575, 2.880325, 2.962075, 3.043825, 3.125575, 3.207325,
    3.289075, 3.370825, 3.425325,
  ],
  upperbounds: [
    2.553325, 2.635075, 2.716825, 2.798575, 2.880325, 2.962075, 3.043825, 3.125575, 3.207325,
    3.289075, 3.370825, 3.425325, 1.746725,
  ],
  values: {
    startLessThan25: [
      1.72555066, 1.78169656, 1.83784246, 1.89398836, 1.95013426, 2.00628016, 2.06242606,
      2.11857196, 2.17471786, 2.23086376, 2.28700966, 2.336917127, 2.38058616,
    ],
    startMoreThan25: [
      1.916016217, 1.978359478, 2.040702739, 2.103046, 2.165389261, 2.227732522, 2.290075783,
      2.352419043, 2.414762304, 2.477105565, 2.539448826, 2.594865058, 2.643354261,
    ],
    endBoar: [
      3.23804556, 3.34340496, 3.44876436, 3.55412376, 3.65948316, 3.76484256, 3.87020196,
      3.97556136, 4.08092076, 4.18628016, 4.29163956, 4.38529236, 4.46723856,
    ],
  },
};

export const COMPARISON_QUICKSIMULATION = {
  startWeight: 25,
  pigletPrice: 25,
  slaughteredWeightInKg: 95,
  revenuePerKg: 1.3,
  calculatedFeedPackagePrice: 35.41,
} as QuickSimulation;

export const COMPARISON_EXTENDEDSIMULATION = {
  id: -1,
  genders: GenderOptions.BOAR_GILT,
  country: CountryOptions.NL,
  startWeight: 25,
  pigletPrice: 25,
  slaughteredWeightInKg: 95,
  revenuePerKg: 1.3,
  feedPackagePrice: 35.41,
  calculatedFeeder: {
    id: 0,
    type: FeederType.END_FEEDER,
    product: {
      id: 0,
      name: 'growfinisher test product',
      code: '3',
      grossPricePer100Kg: 32.9,
      ewKg: 1.07,
      lysKg: 6.96,
      phosphorusGramPerKg: 4.55,
      proteinGramPerKg: 135,
      suitablePhases: [],

      energySystem: null,
      lysineSystem: null,
      schemeTypes: [],
    },
    genderFeedRatios: [
      {
        name: GenderTypes.BOAR,
        feed: 58.5757009345794,
      },
      {
        name: GenderTypes.GILT,
        feed: 122.164485981308,
      },
    ],
  },
  feeders: [
    {
      id: 0,
      type: FeederType.START_FEEDER,
      product: {
        id: 1,
        name: 'start rendement 2',
        code: '1',
        grossPricePer100Kg: 38.85,
        ewKg: 1.1,
        lysKg: 10.7,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 168,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 58,
        },
        {
          name: GenderTypes.GILT,
          feed: 58,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.GROWTH_FEEDER,
      product: {
        name: 'groei effect',
        code: '2',
        grossPricePer100Kg: 35.75,
        ewKg: 1.09,
        lysKg: 8.83,
        phosphorusGramPerKg: 4.5,
        proteinGramPerKg: 159,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 100,
        },
        {
          name: GenderTypes.GILT,
          feed: 55,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.END_FEEDER,
      product: {
        name: 'Vleesvarken effect',
        code: '3',
        grossPricePer100Kg: 32.9,
        ewKg: 1.07,
        lysKg: 6.96,
        phosphorusGramPerKg: 4.55,
        proteinGramPerKg: 135,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 0,
        },
        {
          name: GenderTypes.GILT,
          feed: 0,
        },
      ],
    },
  ],
  baseLine: {
    calculatedPriceLargerThan25Kg: 0.8,
    calculatedPriceLessThan25Kg: 0.8,
    averageWeightPerDeadGrowFinisher: 95,
    growthStartProcedure: 700,
    growthEndProcedure: 850,
  },
  extendedBaseLine: {
    sexe: 1,
    squareMeterPerGrowFinisher: 1,
    startWeight: 25,
    growFinisherPrice: 25,
    revenuePerKg: 1.3,
    slaughteredWeightInKg: 95,
    meatPercentage: 59.8,
    loinDepthThicknessInMillimeters: 68,
    backFatThicknessInMillimeters: 13,
    growth: 874,
    averageEnergyConversion: 2.58,
    mortalityPercentage: 2,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 15,
        days: 14,
      },
      {
        index: 2,
        percentage: 75,
        days: 7,
      },
    ],
    cleaning: 1,
    fertilizerPerGrowFinisherInCubicMeters: 0.851091863546175,
    fertilizerPricePerCubicMeter: 20,
    pigletPrice: 25,
    feedPackagePrice: 35.41,
    toBeAddedValues: {},
  },
} as ExtendedSimulation;

export const EXTENDED_SIMULATION_VIEWABLE_VARIABLES_TABLE = [
  'startWeight',
  'slaughteredWeight',
  'pigletPrice',
  'divergingDaysStartWeight',
  'divergingDaysSlaughteredWeight',
  'divergingDaysGrowth',
  'amountOfDays',
  'growth',
  'occupancyRate',
  'meatPercentage',
  'milimeterMuscle',
  'milimeterNeck',
  'amountOfRounds',
  'divergingEnergyFromGrowthStartStartWeight',
  'divergingEnergyFromGrowthEndDeliveredWeight',
  'divergingEnergyDivergingGrowth',
  'energyConversion',
  'effectDifferentStartWeightOnFeedCosts',
  'effectSlaughteredWeightOnFeedCost',
  'effectDifferenceGrowthOnFeedCost',
  'energyUse',
  'feedPackagePrice',
  'feedCostPerKgPerGrowth',
  'feedProfitPerDeliveredGrowFinisher',
  'profitPerGrowFinisher',
  'feedCosts',
  'costDeathsAndSpoilage',
];

export const EXTENDED_SIMULATION = {
  id: 1,
  genders: GenderOptions.BOAR_GILT,
  country: CountryOptions.NL,
  startWeight: 50,
  pigletPrice: 30,
  slaughteredWeightInKg: 100,
  revenuePerKg: 1.2,
  feedPackagePrice: 34.41,
  calculatedFeeder: null,
  feeders: [
    {
      id: 0,
      type: FeederType.START_FEEDER,
      product: {
        id: 0,
        name: 'start rendement 2',
        code: '1',
        grossPricePer100Kg: 38.85,
        ewKg: 1.1,
        lysKg: 10.7,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 168,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 58,
        },
        {
          name: GenderTypes.GILT,
          feed: 58,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.GROWTH_FEEDER,
      product: {
        name: 'groei effect',
        code: '2',
        grossPricePer100Kg: 35.75,
        ewKg: 1.09,
        lysKg: 8.83,
        phosphorusGramPerKg: 4.5,
        proteinGramPerKg: 159,
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 115,
        },
        {
          name: GenderTypes.GILT,
          feed: 65,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.END_FEEDER,
      product: {
        name: 'Vleesvarken effect',
        code: '3',
        grossPricePer100Kg: 32.9,
        ewKg: 1.07,
        lysKg: 6.96,
        phosphorusGramPerKg: 4.55,
        proteinGramPerKg: 135,
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 0,
        },
        {
          name: GenderTypes.GILT,
          feed: 0,
        },
      ],
    },
  ],
  baseLine: {
    calculatedPriceLargerThan25Kg: 0.8,
    calculatedPriceLessThan25Kg: 0.8,
    averageWeightPerDeadGrowFinisher: 100,
    growthStartProcedure: 700,
    growthEndProcedure: 850,
  },
  extendedBaseLine: {
    sexe: 1,
    squareMeterPerGrowFinisher: 1,
    startWeight: 50,
    growFinisherPrice: 30,
    revenuePerKg: 1.2,
    slaughteredWeightInKg: 100,
    meatPercentage: 59.8,
    loinDepthThicknessInMillimeters: 68,
    backFatThicknessInMillimeters: 13,
    growth: 880,
    averageEnergyConversion: 2.57,
    mortalityPercentage: 2,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 15,
        days: 14,
      },
      {
        index: 2,
        percentage: 75,
        days: 7,
      },
    ],
    cleaning: 1,
    fertilizerPerGrowFinisherInCubicMeters: 0.669,
    fertilizerPricePerCubicMeter: 20,
    feedPackagePrice: 35.41,
    toBeAddedValues: {},
  },
} as ExtendedSimulation;

export const EXTENDED_DIVERGENT_SIMULATION = {
  id: 1,
  genders: GenderOptions.BARROW_GILT,
  country: CountryOptions.NL,
  startWeight: 30,
  pigletPrice: 40,
  slaughteredWeightInKg: 95,
  revenuePerKg: 1.3,
  feedPackagePrice: null,
  calculatedFeeder: null,
  feeders: [
    {
      id: 0,
      type: 'End',
      product: {
        id: 0,
        code: 'B3',
        name: 'Vleesvarkens voer BE 3',
        grossPricePer100Kg: 40.0,
        ewKg: 1.08,
        lysKg: 7.11,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 145.0,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: 'gilt',
          feed: 0.0,
        },
        {
          name: 'barrow',
          feed: 0.0,
        },
      ],
    },
    {
      id: 0,
      type: 'Start',
      product: {
        code: 'B1',
        name: 'Startvoer BE',
        grossPricePer100Kg: 52.0,
        ewKg: 1.1,
        lysKg: 10.0,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 175.0,
      },
      genderFeedRatios: [
        {
          name: 'gilt',
          feed: 58.0,
        },
        {
          name: 'barrow',
          feed: 58.0,
        },
      ],
    },
    {
      id: 0,
      type: 'Growth',
      product: {
        code: 'B2',
        name: 'Groeivoer BE',
        grossPricePer100Kg: 48.0,
        ewKg: 1.12,
        lysKg: 9.0,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 160.0,
      },
      genderFeedRatios: [
        {
          name: 'gilt',
          feed: 65.0,
        },
        {
          name: 'barrow',
          feed: 115.0,
        },
      ],
    },
  ],
  baseLine: {
    calculatedPriceLargerThan25Kg: 1,
    calculatedPriceLessThan25Kg: 1,
    averageWeightPerDeadGrowFinisher: 75,
    growthStartProcedure: 750,
    growthEndProcedure: 750,
  },
  extendedBaseLine: {
    sexe: 2,
    squareMeterPerGrowFinisher: 0.7,
    startWeight: 30,
    growFinisherPrice: 40,
    revenuePerKg: 1.3,
    slaughteredWeightInKg: 95,
    meatPercentage: 57.4,
    loinDepthThicknessInMillimeters: 79.8,
    backFatThicknessInMillimeters: 17,
    growth: 874,
    averageEnergyConversion: 2.85,
    mortalityPercentage: 2,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 90,
        days: 14,
      },
      {
        index: 2,
        percentage: 0,
        days: 0,
      },
    ],
    cleaning: 1,
    fertilizerPerGrowFinisherInCubicMeters: 1.06,
    fertilizerPricePerCubicMeter: 20,
    feedPackagePrice: null,
    toBeAddedValues: {},
  },
} as ExtendedSimulation;

export const DEMO_CALCULATION = {
  id: 0,
  name: '0',
  date: '2022-01-01',
  createdBy: 'me',
  createdAt: '2022-01-01',
  updatedAt: '2022-06-29',
  customerId: 0,
  locationId: 0,
  genders: GenderOptions.BOAR_GILT,
  country: CountryOptions.NL,
  calculatedFeeder: {
    id: 0,
    type: FeederType.END_FEEDER,
    product: {
      id: 0,
      name: 'growfinisher test product',
      code: '3',
      grossPricePer100Kg: 32.9,
      ewKg: 1.07,
      lysKg: 6.96,
      phosphorusGramPerKg: 4.55,
      proteinGramPerKg: 135,
      suitablePhases: [],

      energySystem: null,
      lysineSystem: null,
      schemeTypes: [],
    },
    genderFeedRatios: [
      {
        name: GenderTypes.BOAR,
        feed: 0,
      },
      {
        name: GenderTypes.GILT,
        feed: 0,
      },
    ],
  },
  feeders: [
    {
      id: 0,
      type: FeederType.START_FEEDER,
      product: {
        id: 1,
        name: 'start rendement 2',
        code: '1',
        grossPricePer100Kg: 38.85,
        ewKg: 1.1,
        lysKg: 10.7,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 168,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 58,
        },
        {
          name: GenderTypes.GILT,
          feed: 58,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.GROWTH_FEEDER,
      product: {
        name: 'groei effect',
        code: '2',
        grossPricePer100Kg: 35.75,
        ewKg: 1.09,
        lysKg: 8.83,
        phosphorusGramPerKg: 4.5,
        proteinGramPerKg: 159,
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 100,
        },
        {
          name: GenderTypes.GILT,
          feed: 55,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.END_FEEDER,
      product: {
        name: 'Vleesvarken effect',
        code: '3',
        grossPricePer100Kg: 32.9,
        ewKg: 1.07,
        lysKg: 6.96,
        phosphorusGramPerKg: 4.55,
        proteinGramPerKg: 135,
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 0.5,
        },
        {
          name: GenderTypes.GILT,
          feed: 0.12,
        },
      ],
    },
  ],
  baseLine: {
    calculatedPriceLargerThan25Kg: 0.8,
    calculatedPriceLessThan25Kg: 0.8,
    averageWeightPerDeadGrowFinisher: 75,
    growthStartProcedure: 700,
    growthEndProcedure: 850,
  },
  companyDetails: {
    cause: '',
    priceSetting: PriceSetting.BRUTO,
    numberOfSilos: 1,
    amountOfGrowFinisher: 20,
  },
  extendedBaseLine: {
    sexe: 1,
    squareMeterPerGrowFinisher: 1,
    startWeight: 25,
    growFinisherPrice: 25,
    revenuePerKg: 1.3,
    slaughteredWeightInKg: 95,
    meatPercentage: 59.8,
    loinDepthThicknessInMillimeters: 68,
    backFatThicknessInMillimeters: 13,
    growth: 974,
    averageEnergyConversion: 2.58,
    mortalityPercentage: 2,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 15,
        days: 14,
      },
      {
        index: 2,
        percentage: 75,
        days: 7,
      },
    ],
    cleaning: 1,
    fertilizerPerGrowFinisherInCubicMeters: 0.95,
    fertilizerPricePerCubicMeter: 20,
  },
  comparisonSimulation: {
    id: 0,
    startWeight: 25,
    pigletPrice: 25,
    slaughteredWeightInKg: 95,
    revenuePerKg: 1.3,
    calculatedFeedPackagePrice: 35.41,
    feedPackagePrice: 35.41,
  },
  quickSimulations: [
    {
      id: 1,
      startWeight: 50,
      pigletPrice: 10,
      slaughteredWeightInKg: 95,
      revenuePerKg: 1.3,
      calculatedFeedPackagePrice: 35.41,
      feedPackagePrice: 35.41,
    },
  ],
  extendedComparisonSimulation: COMPARISON_EXTENDEDSIMULATION,
  extendedSimulation: EXTENDED_SIMULATION,
} as Calculation;

export const TESTING_CALCULATION = {
  id: 0,
  name: '0',
  date: '2022-01-01',
  createdBy: 'me',
  createdAt: '2022-01-01',
  updatedAt: '2022-01-01',
  customerId: 0,
  locationId: 0,
  genders: GenderOptions.BOAR_GILT,
  country: CountryOptions.NL,
  calculatedFeeder: {
    id: 0,
    type: FeederType.END_FEEDER,
    product: {
      id: 1,
      name: 'growfinisher test product',
      code: '3',
      grossPricePer100Kg: 32.9,
      ewKg: 1.07,
      lysKg: 6.96,
      phosphorusGramPerKg: 4.55,
      proteinGramPerKg: 135,
      suitablePhases: [],

      energySystem: null,
      lysineSystem: null,
      schemeTypes: [],
    },
    genderFeedRatios: [
      {
        name: GenderTypes.BOAR,
        feed: 58.5757009345794,
      },
      {
        name: GenderTypes.GILT,
        feed: 122.164485981308,
      },
    ],
  },
  feeders: [
    {
      id: 2,
      type: FeederType.START_FEEDER,
      product: {
        id: 1,
        name: 'start rendement 2',
        code: '1',
        grossPricePer100Kg: 38.85,
        ewKg: 1.1,
        lysKg: 10.7,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 168,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 58,
        },
        {
          name: GenderTypes.GILT,
          feed: 58,
        },
      ],
    },
    {
      id: 3,
      type: FeederType.GROWTH_FEEDER,
      product: {
        name: 'groei effect',
        code: '2',
        grossPricePer100Kg: 35.75,
        ewKg: 1.09,
        lysKg: 8.83,
        phosphorusGramPerKg: 4.5,
        proteinGramPerKg: 159,
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 100,
        },
        {
          name: GenderTypes.GILT,
          feed: 55,
        },
      ],
    },
    {
      id: 4,
      type: FeederType.END_FEEDER,
      product: {
        name: 'Vleesvarken effect',
        code: '3',
        grossPricePer100Kg: 32.9,
        ewKg: 1.07,
        lysKg: 6.96,
        phosphorusGramPerKg: 4.55,
        proteinGramPerKg: 135,
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 0,
        },
        {
          name: GenderTypes.GILT,
          feed: 0,
        },
      ],
    },
  ],
  baseLine: {
    calculatedPriceLargerThan25Kg: 0.8,
    calculatedPriceLessThan25Kg: 0.8,
    averageWeightPerDeadGrowFinisher: 95,
    growthStartProcedure: 700,
    growthEndProcedure: 850,
  },
  companyDetails: {
    cause: '',
    priceSetting: PriceSetting.BRUTO,
    numberOfSilos: 4,
    amountOfGrowFinisher: 20,
  },
  extendedBaseLine: {
    sexe: 1,
    squareMeterPerGrowFinisher: 1,
    startWeight: 25,
    growFinisherPrice: 25,
    revenuePerKg: 1.3,
    slaughteredWeightInKg: 95,
    meatPercentage: 59.8,
    loinDepthThicknessInMillimeters: 68,
    backFatThicknessInMillimeters: 13,
    growth: 874,
    averageEnergyConversion: 2.58,
    mortalityPercentage: 2,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 15,
        days: 14,
      },
      {
        index: 2,
        percentage: 75,
        days: 7,
      },
    ],
    cleaning: 1,
    fertilizerPerGrowFinisherInCubicMeters: 0.851091863546175,
    fertilizerPricePerCubicMeter: 20,
  },
  comparisonSimulation: {
    id: 0,
    startWeight: 25,
    pigletPrice: 25,
    slaughteredWeightInKg: 95,
    revenuePerKg: 1.3,
    calculatedFeedPackagePrice: 35.41,
    feedPackagePrice: 35.41,
  },
  quickSimulations: [
    {
      id: 1,
      startWeight: 50,
      pigletPrice: 10,
      slaughteredWeightInKg: 95,
      revenuePerKg: 1.3,
      calculatedFeedPackagePrice: 35.41,
      feedPackagePrice: 35.41,
    },
  ],
  extendedComparisonSimulation: COMPARISON_EXTENDEDSIMULATION,
  extendedSimulation: EXTENDED_SIMULATION,
} as Calculation;

export const DIVERGENTCALCULATION_QUICKSIM = {
  ...TESTING_CALCULATION,
  genders: GenderOptions.BARROW_GILT,
  country: CountryOptions.NL,
  calculatedFeeder: {
    id: 0,
    type: 'End',
    product: {
      id: 0,
      code: 'B3',
      name: 'Vleesvarkens voer BE 3',
      grossPricePer100Kg: 40.0,
      ewKg: 1.08,
      lysKg: 7.11,
      phosphorusGramPerKg: 4.6,
      proteinGramPerKg: 145.0,
      suitablePhases: [],

      energySystem: null,
      lysineSystem: null,
      schemeTypes: [],
    },
    genderFeedRatios: [
      {
        name: 'gilt',
        feed: 51.29629629629627,
      },
      {
        name: 'barrow',
        feed: 81.94444444444444,
      },
    ],
  },
  feeders: [
    {
      id: 0,
      type: 'End',
      product: {
        id: 1,
        code: 'B3',
        name: 'Vleesvarkens voer BE 3',
        grossPricePer100Kg: 40.0,
        ewKg: 1.08,
        lysKg: 7.11,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 145.0,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: 'gilt',
          feed: 0.0,
        },
        {
          name: 'barrow',
          feed: 0.0,
        },
      ],
    },
    {
      id: 0,
      type: 'Start',
      product: {
        code: 'B1',
        name: 'Startvoer BE',
        grossPricePer100Kg: 52.0,
        ewKg: 1.1,
        lysKg: 10.0,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 175.0,
      },
      genderFeedRatios: [
        {
          name: 'gilt',
          feed: 60.0,
        },
        {
          name: 'barrow',
          feed: 55.0,
        },
      ],
    },
    {
      id: 0,
      type: 'Growth',
      product: {
        code: 'B2',
        name: 'Groeivoer BE',
        grossPricePer100Kg: 48.0,
        ewKg: 1.12,
        lysKg: 9.0,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 160.0,
      },
      genderFeedRatios: [
        {
          name: 'gilt',
          feed: 70.0,
        },
        {
          name: 'barrow',
          feed: 55.0,
        },
      ],
    },
  ],
  companyDetails: {
    cause: 'Test BE',
    priceSetting: 'Netto',
    numberOfSilos: 8500,
    amountOfGrowFinisher: 8500,
  },
  baseLine: {
    calculatedPriceLargerThan25Kg: 1.0,
    calculatedPriceLessThan25Kg: 1.0,
    averageWeightPerDeadGrowFinisher: 75.0,
    growthStartProcedure: 750.0,
    growthEndProcedure: 830.0,
  },
  extendedBaseLine: {
    squareMeterPerGrowFinisher: 0.7,
    startWeight: 23.0,
    growFinisherPrice: 55.0,
    revenuePerKg: 1.81,
    slaughteredWeightInKg: 75.0,
    meatPercentage: 59.0,
    loinDepthThicknessInMillimeters: 74.0,
    backFatThicknessInMillimeters: 14.0,
    growth: 850.0,
    averageEnergyConversion: 2.85,
    mortalityPercentage: 2.0,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 90,
        days: 14,
      },
      {
        index: 2,
        percentage: 0,
        days: 0,
      },
    ],
    cleaning: 1.0,
    fertilizerPerGrowFinisherInCubicMeters: 0.9487699571775333,
    fertilizerPricePerCubicMeter: 15.0,
  },
  quickSimulations: [
    {
      id: 1.0,
      startWeight: 5.0,
      pigletPrice: 5.0,
      slaughteredWeightInKg: 0.0,
      revenuePerKg: 0.0,
      calculatedFeedPackagePrice: 0.0,
      feedPackagePrice: 0.0,
    },
    {
      id: 2.0,
      startWeight: 30.0,
      pigletPrice: 40.0,
      slaughteredWeightInKg: 95.0,
      revenuePerKg: 1.3,
      calculatedFeedPackagePrice: 199.53,
      feedPackagePrice: 199.53,
    },
  ],
  comparisonSimulation: {
    id: 0.0,
    startWeight: 23.0,
    pigletPrice: 55.0,
    slaughteredWeightInKg: 75.0,
    revenuePerKg: 1.81,
    calculatedFeedPackagePrice: 46.37658149342595,
    feedPackagePrice: 46.37658149342595,
  },
  extendedSimulation: undefined,
} as Calculation;

export const DIVERGENTCALCULATION_EXTENDEDSIM = {
  ...TESTING_CALCULATION,
  genders: GenderOptions.BARROW_GILT,
  country: CountryOptions.NL,
  calculatedFeeder: {
    id: 0,
    type: 'End',
    product: {
      id: 3,
      code: 'B3',
      name: 'Vleesvarkens voer BE 3',
      grossPricePer100Kg: 40.0,
      ewKg: 1.08,
      lysKg: 7.11,
      phosphorusGramPerKg: 4.6,
      proteinGramPerKg: 145.0,
      suitablePhases: [],

      energySystem: null,
      lysineSystem: null,
      schemeTypes: [],
    },
    genderFeedRatios: [
      {
        name: 'gilt',
        feed: 51.29629629629627,
      },
      {
        name: 'barrow',
        feed: 81.94444444444444,
      },
    ],
  },
  feeders: [
    {
      id: 0,
      type: 'End',
      product: {
        id: 1,
        code: 'B3',
        name: 'Vleesvarkens voer BE 3',
        grossPricePer100Kg: 40.0,
        ewKg: 1.08,
        lysKg: 7.11,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 145.0,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: 'gilt',
          feed: 0.0,
        },
        {
          name: 'barrow',
          feed: 0.0,
        },
      ],
    },
    {
      id: 0,
      type: 'Start',
      product: {
        id: 1,
        code: 'B1',
        name: 'Startvoer BE',
        grossPricePer100Kg: 52.0,
        ewKg: 1.1,
        lysKg: 10.0,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 175.0,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: 'gilt',
          feed: 60.0,
        },
        {
          name: 'barrow',
          feed: 55.0,
        },
      ],
    },
    {
      id: 0,
      type: 'Growth',
      product: {
        id: 2,
        code: 'B2',
        name: 'Groeivoer BE',
        grossPricePer100Kg: 48.0,
        ewKg: 1.12,
        lysKg: 9.0,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 160.0,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: 'gilt',
          feed: 70.0,
        },
        {
          name: 'barrow',
          feed: 55.0,
        },
      ],
    },
  ],
  companyDetails: {
    cause: 'Test BE',
    priceSetting: 'Netto',
    numberOfSilos: 8500,
    amountOfGrowFinisher: 8500,
  },
  baseLine: {
    calculatedPriceLargerThan25Kg: 1.0,
    calculatedPriceLessThan25Kg: 1.0,
    averageWeightPerDeadGrowFinisher: 75.0,
    growthStartProcedure: 750.0,
    growthEndProcedure: 750.0,
  },
  extendedBaseLine: {
    squareMeterPerGrowFinisher: 0.7,
    startWeight: 23.0,
    growFinisherPrice: 55.0,
    revenuePerKg: 1.81,
    slaughteredWeightInKg: 75.0,
    meatPercentage: 59.0,
    loinDepthThicknessInMillimeters: 74.0,
    backFatThicknessInMillimeters: 14.0,
    growth: 850.0,
    averageEnergyConversion: 2.85,
    mortalityPercentage: 2.0,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 90,
        days: 14,
      },
      {
        index: 2,
        percentage: 0,
        days: 0,
      },
    ],
    cleaning: 1.0,
    fertilizerPerGrowFinisherInCubicMeters: 0.9487699571775333,
    fertilizerPricePerCubicMeter: 15.0,
  },
  quickSimulations: [
    {
      id: 1.0,
      startWeight: 5.0,
      pigletPrice: 5.0,
      slaughteredWeightInKg: 0.0,
      revenuePerKg: 0.0,
      calculatedFeedPackagePrice: 0.0,
    },
    {
      id: 2.0,
      startWeight: 30.0,
      pigletPrice: 40.0,
      slaughteredWeightInKg: 95.0,
      revenuePerKg: 1.3,
      calculatedFeedPackagePrice: 199.53,
    },
  ],
  comparisonSimulation: {
    id: 0.0,
    startWeight: 23.0,
    pigletPrice: 55.0,
    slaughteredWeightInKg: 75.0,
    revenuePerKg: 1.81,
    calculatedFeedPackagePrice: 46.37658149342595,
  },
  extendedSimulation: EXTENDED_DIVERGENT_SIMULATION,
  extendedComparisonSimulation: null,
} as Calculation;

export const CALCULATION_QUICKSIM = {
  id: 0,
  name: '0',
  date: '2022-01-01',
  createdBy: 'me',
  createdAt: '2022-01-01',
  updatedAt: '2022-01-01',
  customerId: 0,
  locationId: 0,
  genders: GenderOptions.BOAR_GILT,
  country: CountryOptions.NL,
  calculatedFeeder: {
    id: 0,
    type: FeederType.END_FEEDER,
    product: {
      id: 0,
      name: 'growfinisher test product',
      code: '3',
      grossPricePer100Kg: 32.9,
      ewKg: 1.07,
      lysKg: 6.96,
      phosphorusGramPerKg: 4.55,
      proteinGramPerKg: 135,
      suitablePhases: [],
      energySystem: null,
      lysineSystem: null,
      schemeTypes: [],
    },
    genderFeedRatios: [
      {
        name: GenderTypes.BOAR,
        feed: 0,
      },
      {
        name: GenderTypes.GILT,
        feed: 0,
      },
    ],
  },
  feeders: [
    {
      id: 0,
      type: FeederType.START_FEEDER,
      product: {
        id: 1,
        name: 'start rendement 2',
        code: '1',
        grossPricePer100Kg: 38.85,
        ewKg: 1.1,
        lysKg: 10.7,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 168,
        suitablePhases: [],
        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 58,
        },
        {
          name: GenderTypes.GILT,
          feed: 58,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.GROWTH_FEEDER,
      product: {
        name: 'groei effect',
        code: '2',
        grossPricePer100Kg: 35.75,
        ewKg: 1.09,
        lysKg: 8.83,
        phosphorusGramPerKg: 4.5,
        proteinGramPerKg: 159,
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 100,
        },
        {
          name: GenderTypes.GILT,
          feed: 55,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.END_FEEDER,
      product: {
        name: 'Vleesvarken effect',
        code: '3',
        grossPricePer100Kg: 32.9,
        ewKg: 1.07,
        lysKg: 6.96,
        phosphorusGramPerKg: 4.55,
        proteinGramPerKg: 135,
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BOAR,
          feed: 0,
        },
        {
          name: GenderTypes.GILT,
          feed: 0,
        },
      ],
    },
  ],
  baseLine: {
    calculatedPriceLargerThan25Kg: 0.8,
    calculatedPriceLessThan25Kg: 0.8,
    averageWeightPerDeadGrowFinisher: 75,
    growthStartProcedure: 700,
    growthEndProcedure: 850,
  },
  companyDetails: {
    cause: '',
    priceSetting: PriceSetting.BRUTO,
    numberOfSilos: 1,
    amountOfGrowFinisher: 20,
  },
  extendedBaseLine: {
    sexe: 1,
    squareMeterPerGrowFinisher: 1,
    startWeight: 25,
    growFinisherPrice: 25,
    revenuePerKg: 1.3,
    slaughteredWeightInKg: 95,
    meatPercentage: 59.8,
    loinDepthThicknessInMillimeters: 68,
    backFatThicknessInMillimeters: 13,
    growth: 974,
    averageEnergyConversion: 2.58,
    mortalityPercentage: 2,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 15,
        days: 14,
      },
      {
        index: 2,
        percentage: 75,
        days: 7,
      },
    ],
    cleaning: 1,
    fertilizerPerGrowFinisherInCubicMeters: 0.95,
    fertilizerPricePerCubicMeter: 20,
  },
  comparisonSimulation: {
    id: 0,
    startWeight: 25,
    pigletPrice: 25,
    slaughteredWeightInKg: 95,
    revenuePerKg: 1.3,
    calculatedFeedPackagePrice: 35.4057544862856,
    feedPackagePrice: 35.4057544862856,
  },
  quickSimulations: [
    {
      id: 1,
      startWeight: 50,
      pigletPrice: 10,
      slaughteredWeightInKg: 95,
      revenuePerKg: 1.3,
      calculatedFeedPackagePrice: 35.4057544862856,
      feedPackagePrice: 35.4057544862856,
    },
  ],
  extendedSimulation: undefined,
  extendedComparisonSimulation: undefined,
} as Calculation;

export const CALCULATION_QUICKSIM_NET = {
  id: 0,
  name: '0',
  date: '2022-01-01',
  createdBy: 'me',
  createdAt: '2022-01-01',
  updatedAt: '2022-01-01',
  customerId: 0,
  locationId: 0,
  genders: GenderOptions.BARROW_GILT,
  country: CountryOptions.NL,
  calculatedFeeder: {
    id: 0,
    type: FeederType.END_FEEDER,
    product: {
      id: 0,
      name: 'growfinisher test product',
      code: '3',
      grossPricePer100Kg: 40,
      ewKg: 1.08,
      lysKg: 7.11,
      phosphorusGramPerKg: 4.6,
      proteinGramPerKg: 145,
      suitablePhases: [],
      energySystem: null,
      lysineSystem: null,
      schemeTypes: [],
    },
    genderFeedRatios: [
      {
        name: GenderTypes.BARROW,
        feed: 0,
      },
      {
        name: GenderTypes.GILT,
        feed: 0,
      },
    ],
  },
  feeders: [
    {
      id: 0,
      type: FeederType.START_FEEDER,
      product: {
        id: 2,
        name: 'start rendement 2',
        code: '1',
        grossPricePer100Kg: 52,
        ewKg: 1.1,
        lysKg: 10,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 175,
        suitablePhases: [],
        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BARROW,
          feed: 50,
        },
        {
          name: GenderTypes.GILT,
          feed: 60,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.GROWTH_FEEDER,
      product: {
        id: 3,
        name: 'groei effect',
        code: '2',
        grossPricePer100Kg: 48,
        ewKg: 1.12,
        lysKg: 9,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 160,
        suitablePhases: [],
        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BARROW,
          feed: 50,
        },
        {
          name: GenderTypes.GILT,
          feed: 70,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.END_FEEDER,
      product: {
        id: 4,
        name: 'growfinisher test product',
        code: '3',
        grossPricePer100Kg: 40,
        ewKg: 1.08,
        lysKg: 7.11,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 145,
        suitablePhases: [],
        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BARROW,
          feed: 0,
        },
        {
          name: GenderTypes.GILT,
          feed: 0,
        },
      ],
    },
  ],
  baseLine: {
    calculatedPriceLargerThan25Kg: 1,
    calculatedPriceLessThan25Kg: 1,
    averageWeightPerDeadGrowFinisher: 75,
    growthStartProcedure: 750,
    growthEndProcedure: 900,
  },
  companyDetails: {
    cause: '',
    priceSetting: PriceSetting.NETTO,
    numberOfSilos: 3,
    amountOfGrowFinisher: 100,
  },
  extendedBaseLine: {
    sexe: 2,
    squareMeterPerGrowFinisher: 0.7,
    startWeight: 23,
    growFinisherPrice: 55,
    revenuePerKg: 1.8,
    slaughteredWeightInKg: 98,
    meatPercentage: 74,
    loinDepthThicknessInMillimeters: 74,
    backFatThicknessInMillimeters: 14,
    growth: 870,
    averageEnergyConversion: 2.83,
    mortalityPercentage: 2,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 90,
        days: 14,
      },
      {
        index: 2,
        percentage: 0,
        days: 0,
      },
    ],
    cleaning: 1,
    fertilizerPerGrowFinisherInCubicMeters: 0.9609661882223688,
    fertilizerPricePerCubicMeter: 15,
  },
  comparisonSimulation: {
    id: 0,
    startWeight: 23,
    pigletPrice: 55,
    slaughteredWeightInKg: 98,
    revenuePerKg: 1.8,
    calculatedFeedPackagePrice: 41.80131755891483,
    feedPackagePrice: 41.80131755891483,
  },
  quickSimulations: [
    {
      id: 1,
      startWeight: 25,
      pigletPrice: 55,
      slaughteredWeightInKg: 98,
      revenuePerKg: 1.8,
      calculatedFeedPackagePrice: 41.8013175589148,
      feedPackagePrice: 41.8013175589148,
    },
  ],
  extendedSimulation: undefined,
  extendedComparisonSimulation: undefined,
} as Calculation;

export const EXTENDED_SIMULATION_NET: ExtendedSimulation = {
  genders: GenderOptions.BOAR_GILT,
  country: CountryOptions.NL,
  startWeight: 27,
  pigletPrice: 50,
  slaughteredWeightInKg: 100,
  revenuePerKg: 1.6,
  feedPackagePrice: 0,
  feeders: [
    {
      id: 0,
      type: FeederType.START_FEEDER,
      product: {
        id: 0,
        name: 'start rendement 2',
        code: '1',
        grossPricePer100Kg: 52,
        ewKg: 1.1,
        lysKg: 10,
        phosphorusGramPerKg: 4.8,
        proteinGramPerKg: 175,
        suitablePhases: [],
        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BARROW,
          feed: 50,
        },
        {
          name: GenderTypes.GILT,
          feed: 60,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.GROWTH_FEEDER,
      product: {
        id: 1,
        name: 'groei effect',
        code: '2',
        grossPricePer100Kg: 48,
        ewKg: 1.12,
        lysKg: 9,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 160,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BARROW,
          feed: 100,
        },
        {
          name: GenderTypes.GILT,
          feed: 100,
        },
      ],
    },
    {
      id: 0,
      type: FeederType.END_FEEDER,
      product: {
        id: 2,
        name: 'growfinisher test product',
        code: '3',
        grossPricePer100Kg: 40,
        ewKg: 1.08,
        lysKg: 7.11,
        phosphorusGramPerKg: 4.6,
        proteinGramPerKg: 145,
        suitablePhases: [],

        energySystem: null,
        lysineSystem: null,
        schemeTypes: [],
      },
      genderFeedRatios: [
        {
          name: GenderTypes.BARROW,
          feed: 0,
        },
        {
          name: GenderTypes.GILT,
          feed: 0,
        },
      ],
    },
  ],
  calculatedFeeder: {
    id: 0,
    type: FeederType.END_FEEDER,
    product: {
      id: 3,
      name: 'growfinisher test product',
      code: '3',
      grossPricePer100Kg: 40,
      ewKg: 1.08,
      lysKg: 7.11,
      phosphorusGramPerKg: 4.6,
      proteinGramPerKg: 145,
      suitablePhases: [],

      energySystem: null,
      lysineSystem: null,
      schemeTypes: [],
    },
    genderFeedRatios: [
      {
        name: GenderTypes.BARROW,
        feed: 0,
      },
      {
        name: GenderTypes.GILT,
        feed: 0,
      },
    ],
  },
  baseLine: {
    calculatedPriceLargerThan25Kg: 1,
    calculatedPriceLessThan25Kg: 1,
    averageWeightPerDeadGrowFinisher: 75,
    growthEndProcedure: 900,
    growthStartProcedure: 750,
  },
  extendedBaseLine: {
    squareMeterPerGrowFinisher: 0.9,
    startWeight: 27,
    growFinisherPrice: 50,
    revenuePerKg: 1.6,
    slaughteredWeightInKg: 100,
    meatPercentage: 59.2,
    loinDepthThicknessInMillimeters: 74,
    backFatThicknessInMillimeters: 14,
    growth: 900,
    averageEnergyConversion: 2.5,
    mortalityPercentage: 2,
    feedPackagePrice: 0,
    deliveries: [
      {
        index: 0,
        percentage: 10,
        days: 0,
      },
      {
        index: 1,
        percentage: 90,
        days: 14,
      },
      {
        index: 2,
        percentage: 0,
        days: 0,
      },
    ],
    cleaning: 1,
    fertilizerPerGrowFinisherInCubicMeters: 0.9609661882223688,
    fertilizerPricePerCubicMeter: 16,
  },
};

export const DISCOUNTS: Discount = {
  bulkDiscountPer100Kg: 0.3,
  purchaseDiscountPer100Kg: 0.7,
  deliveryDayDiscountPer100Kg: 0.3,
  paymentDiscountPercentage: 1,
  memberBenefitDiscountPercentage: 1.5,
  memberDiscountPer100Kg: 0.25,
};
